<form [formGroup]="form">
  <mat-chip-listbox multiple formControlName="selectedIds">
    @for (pValue of possibleValues; track pValue; let index = $index) {
      <ng-container
        *ngVar="(selected$|async)|transformValueByPredicateFunction:isSelectedPredicate:pValue as selected">
        <mat-chip-option
          [selected]="selected"
          [color]="selected?(index%2?'primary':'accent'):undefined"
          [matMenuTriggerFor]="(!(selected)||!pValue.openMenu())?null:menu"
          (click)="setLastClick(pValue)"
          [value]="pValue.objectId"
          >
          {{ pValue.traductionNoTraduction|traductionNotTraduction|async }}
          @if (pValue.openMenu()&&selected) {
            <mat-icon matChipTrailingIcon
              (click)="$event.stopPropagation();setLastClick(pValue)"
              [matMenuTriggerFor]="pValue.openMenu()?menu:null"
              svgIcon="menuRound"
              style="cursor: pointer;"
              >
            </mat-icon>
          }
        </mat-chip-option>
      </ng-container>
    }
  </mat-chip-listbox>

</form>


<mat-menu #menu="matMenu" (closed)="menuClosed()" class="custom-mat-menu">
  @if (lastClick$|async; as lastClick) {
    @if (lastClick.selectablePossibleValues) {
      <mat-selection-list>
        @for (pValue of (lastClick.selectablePossibleValues)|keyvalue; track pValue) {
          <mat-list-option
            [selected]="lastClick.isSelected(pValue.key)"
            (click)="$event.stopPropagation();lastClick.addOrRemove(pValue.key);updateValue()">
            {{ pValue.value.traductionNoTraduction|traductionNotTraduction|async }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
    @if (lastClick.rangesPossibleValues) {
      @for (pRangeValue of (lastClick.rangesPossibleValues)|keyvalue; track pRangeValue) {
        <app-form-field-range [showSlider]="false" (click)="$event.stopPropagation()"
          [title]="(pRangeValue.value.traductionNoTraduction|traductionNotTraduction|async)!"
          [initMin]="pRangeValue.value.min"
          [initMax]="pRangeValue.value.max"
          (emitValue)="lastClick.addOrRemoveRange(pRangeValue.value,$event);updateValue()">
        </app-form-field-range>
      }
    }
  }

  <div style="padding: 0 15px;width: 400px"></div>

</mat-menu>
